<template>
  <div class="workflows-section mt-8" data-testid="workflows-section">
    <h2 class="text-xl font-semibold mb-3">Workflows</h2>
    <p class="text-sm text-zinc-600 dark:text-zinc-400 mb-6">
      Set up automatic or 1-click integrations with Zight. Automatically create content from step-by-step guides or update your customer tickets when receiving
      videos.
    </p>
    <p v-if="!hasBusinessPlan" class="zt-info-box mb-6" data-testid="plan-notice">
      Please note: 1-click integrations are available on our Enterprise plan. Contact your customer success manager to help you get set up.
    </p>
    <template v-if="hasIntegrations">
      <div data-testid="integrations-grid-container">
        <IntegrationsGrid />
      </div>
    </template>
    <template v-else-if="loading">
      <div class="flex items-center justify-center py-8" data-testid="loading-state">
        <div class="text-zinc-500">Loading integrations...</div>
      </div>
    </template>
    <template v-else-if="error">
      <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6" data-testid="error-state">
        <p class="text-red-700">{{ error }}</p>
      </div>
    </template>
    <template v-else>
      <p data-testid="no-integrations-message">No integrations available. Contact your account admin to enable them.</p>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import IntegrationsGrid from './IntegrationsGrid.vue';
import { useIntegrationStore } from '../store/useIntegrationStore';
import { useOrganizationStore } from '@/store/useOrganizationStore';

const integrationStore = useIntegrationStore();
const organizationStore = useOrganizationStore();

const { integrations, loading, error } = storeToRefs(integrationStore);
const { hasBusinessPlan } = storeToRefs(organizationStore);

const hasIntegrations = computed(() => integrations.value.length > 0);
</script>

<style scoped>
.zt-info-box {
  @apply bg-blue-50 border border-blue-200 p-4 rounded mt-4 mb-8 text-zinc-700;
  @apply dark:bg-blue-900 dark:border-blue-500 dark:text-zinc-200;
}
</style>
